import React, { useEffect, useState } from 'react'
import DashboardAreaSummary from './DashboardAreaSummary'
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { getProfile } from '../../reducer/profileSlice';
import DashboardEocSummary from './DashboardEocSummary';

function Dashboard() {
    const profile = useSelector(getProfile);
    const [summary, setSummary] = useState([]);

    useEffect(() => {
        let level = parseInt(profile?.org_level);
        let list = []
        if (level < 2) {
            list.push("02");
        }
        if (level < 3) {
            list.push("03");
        }
        if (level < 4) {
            list.push("04");
        }
        setSummary(list);
        
    }, [profile])    

    return (
        <div style={{
            width: '100%',
            height: 'calc(100vh - 60px)',
            padding: '24px',
            overflow: 'auto',
        }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <DashboardEocSummary></DashboardEocSummary>
                </Grid>
                {
                    summary.map((data, index) => {
                        let size = 12/summary.length;
                        return (
                            <Grid key={index} item md={size} xs={12} sm={12}>
                                <DashboardAreaSummary level={data}></DashboardAreaSummary>
                            </Grid>
                        )
                    })
                }
                {/* <Grid item md={4} xs={12} sm={12}>
                    <DashboardAreaSummary level={"02"}></DashboardAreaSummary>
                </Grid>
                <Grid item md={4} xs={12} sm={12}>
                    <DashboardAreaSummary level={"03"}></DashboardAreaSummary>
                </Grid>
                <Grid item md={4} xs={12} sm={12}>
                    <DashboardAreaSummary level={"04"}></DashboardAreaSummary>
                </Grid> */}
            </Grid>
        </div>
    )
}

export default Dashboard
